import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerMultiSelectDataSource } from '../../extension/multi-select/eager-multi-select-data-source';
import { PhoneNumberOption } from '../models/phone-number-option';
import { phoneNumberOptionActions } from '../state/phone-number-option.actions';
import { phoneNumberOptionSelectors } from '../state/phone-number-option.reducer';

export class PhoneNumberMultiSelectDataSource extends EagerMultiSelectDataSource<PhoneNumberOption> {
   constructor(store: Store<AppState>, filterOverrides: string[]) {
      super(store, phoneNumberOptionActions, phoneNumberOptionSelectors);
      this.filterOverrides = filterOverrides;
   }

   compareWith(a: PhoneNumberOption, b: PhoneNumberOption): boolean {
      return a.phoneNumberId === b.phoneNumberId;
   }
}
